module.exports = __webpack_public_path__ + "img/snooker-dark.132e91a2.svg";